import React from "react";
import Loader from 'react-loader-spinner';
import { orange } from '@mui/material/colors';

const LoaderIndicator = () => {

    const primary=orange[800];

    return (
        <div className="d-flex justify-content-center align-items-center loading-page">
            <Loader type="ThreeDots" color={primary} height="150" width="150" />
        </div>
    );
}

export default LoaderIndicator;